import React from 'react';
import { CheckCircleOutlined } from '@ant-design/icons';
import { QRCode } from 'antd';
import dayjs from 'dayjs';

import './PreparingFood.less';

const PreparingFood = ({ orderData }) => {
	const { start_time, end_time, order_status, price, meal_name, drink_name, token, display_id, locker_name, order_customizations } = orderData;
	const drinkCustomizations = order_customizations ? order_customizations.filter(item => item.customization_type === 'drink') : null;
	const mealCustomizations = order_customizations ? order_customizations.filter(item => item.customization_type === 'meal') : null;

	const total = price + order_customizations.reduce((sum, item) => sum + item.option_price || 0, 0);

	// Determine badge label based on order_status
	const badgeLabel = order_status === 'pending' ? 'Pending' : '備餐中 Preparing Food';

	return (
		<div className="preparing-food">
			<div className="preparing-food-header">
				<div className="success-icon-wrapper">
					<CheckCircleOutlined className="success-icon" />
				</div>
				<h2 className="preparing-food-title">訂單已確認 Order Confirmed</h2>
				<p className="preparing-food-subtitle">
					餐點準備好取餐時，我們會透過電郵通知您
					<br />
					You will be notified by email once your order is ready for pickup.
				</p>
			</div>

			<div className="order-details-section">
				<div className="qr-code-section">
					<QRCode
						value={token}
						size={300}
						className="qr-code-image"
					/>
				</div>

				<div className="order-status-badge preparing">
					<span>{badgeLabel}</span>
				</div>

				<div className="order-detail-row">
					<span className="detail-label">訂單編號 Order ID</span>
					<span className="detail-value">{display_id}</span>
				</div>

				<div className="order-detail-row">
					<span className="detail-label">取餐時段 Pickup Timeslot</span>
					<span className="detail-value">{start_time && end_time ? `${dayjs(start_time).format('HH:mm')} - ${dayjs(end_time).format('HH:mm')}` : 'N/A'}</span>
				</div>

				<div className="order-detail-row">
					<span className="detail-label">食物櫃 Food Locker</span>
					<span className="detail-value">{locker_name}</span>
				</div>

				<div className="order-detail-row">
					<span className="detail-label">訂單摘要 Order Summary</span>
					<div className="detail-value">
						<div>• {meal_name}</div>
						{mealCustomizations &&
							<ul style={{ listStyle: 'circle' }}>
								{mealCustomizations.map(option => (
									<li>{option.option_name}</li>
								))}
							</ul>
						}
						{drink_name && <div>• {drink_name}</div>}
						{drinkCustomizations &&
							<ul style={{ listStyle: 'circle' }}>
								{drinkCustomizations.map(option => (
									<li>{option.option_name}</li>
								))}
							</ul>
						}
					</div>
				</div>

				<div className="order-detail-row">
					<span className="detail-label">總額 Total</span>
					<span className="detail-value">${total.toFixed(2)}</span>
				</div>

				<div className="order-detail-row">
					<span className="detail-label">下一步? What happens next?</span>
					<div className="detail-value">
						<div>• 我們正在準備您的訂單。</div>
						<div>• 餐點準備好取餐時，我們會透過電郵通知您。</div>
						<div>• 請於選定取餐時段內，使用二維碼到指定食物櫃領取餐點。</div>
						<div>• 您只可在選定的取餐時段內領取餐點。若逾時未取餐，基於食物安全及衛生考慮，該餐點將被棄置，我們不會提供任何補償或退款。</div>
					</div>
					<br />
					<div className="detail-value">
						<div>• We are prepraing your order.</div>
						<div>• You will be notified by email once your order is ready for pickup.</div>
						<div>• Use the QR Code to pick up your meal at the designated food locker during your selected timeslot.</div>
						<div>• You may only collect your order during the selected pickup timeslot. If not collected on time, the meal will be discarded for food safety and hygiene reasons. No compensation or refund will be provided in such cases.</div>
					</div>
				</div>

				{/* <div className="what-happens-next">
					<h3 className="what-happens-title">下一步? What happens next?</h3>
					<ul className="what-happens-list"></ul>
				</div> */}
			</div>
		</div>
	);
};

export default PreparingFood;
